<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 login-section-wrapper">
        <!-- <div class="brand-wrapper">
            <img src="../assets/images/logo.svg" alt="logo" class="logo">
          </div> -->
        <div class="login-wrapper my-auto">
          <h1 class="login-title">Log in</h1>
          <Form @submit="handleLogin"
                :validation-schema="schema">
            <div class="form-group">
              <label for="email">Email</label>
              <Field name="email"
                     class="form-control"
                     placeholder="enter your email" />
              <ErrorMessage name="email"
                            class="error-feedback" />
            </div>
            <div class="form-group mb-4">
              <label for="password">Password</label>
              <Field type="password"
                     name="password"
                     id="password"
                     class="form-control"
                     placeholder="enter your passsword" />
              <ErrorMessage name="password"
                            class="error-feedback" />
            </div>

            <div class="form-group">
              <button class="btn btn-block login-btn"
                      :disabled="loading">
                <span v-show="loading"
                      class="spinner-border spinner-border-sm"></span>
                <span>Login</span>
              </button>
            </div>
            <div class="form-group">
              <div v-if="message"
                   class="alert alert-danger"
                   role="alert">
                {{ message }}
              </div>
            </div>
          </Form>
          <p class="forgot-password-link">
            <router-link to="/forgotpassword">Forgot password?</router-link>
          </p>
          <p class="login-wrapper-footer-text">Don't have an account?
            <router-link to="/register">Register here</router-link>
          </p>
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block">
        <img src="../assets/images/login.jpg"
             alt="login image"
             class="login-img">
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'

export default {
  name: 'Login',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      email: yup
        .string()
        .required('Email is required')
        .email('Email is invalid'),
      password: yup.string().required('Password is required!'),
    })

    return {
      loading: false,
      message: '',
      schema,
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/analyzer')
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true
      this.$store.dispatch('auth/login', user).then(
        () => {
          this.$router.push('/analyzer')
        },
        (error) => {
          this.loading = false
          // this.message = "Invalid email or password"
          if (error.response.data.non_field_errors[0].includes('Unable to')) {
            this.message = 'Invalid email or password'
          }
          if (error.response.data.non_field_errors[0].includes('E-mail')) {
            this.message = 'E-mail is not verified.'
          }
          // this.message = error.response.data.non_field_errors
          // this.message = "Invalid email or password"
          // this.message = "Invalid email or password"
        }
      )
    },
  },
}
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}

.btn {
  width: 120px;
}

.ForPass {
  text-align: right;
}
</style>
